import { Pressable, StyleSheet, View } from 'react-native';
import { BodyText, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────

export const NotificationPreferencesNotice = (
  props: NotificationsPreferencesNoticeProps,
) => {
  const { notice, actionText, onPress } = props;

  return (
    <View style={styles.container}>
      <BodyText sizeMatch={['14']} style={styles.noticeText}>
        {notice}
      </BodyText>

      <Pressable accessibilityRole="button" onPress={onPress}>
        <BodyText sizeMatch={['14']} style={styles.actionText} bold>
          {actionText}
        </BodyText>
      </Pressable>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.colors.CUCUMBER,
    borderRadius: theme.radius.large,
    padding: theme.spacing['5'],
    marginBottom: theme.spacing['5'],
  },
  noticeText: {
    color: theme.colors.DARK_KALE,
    paddingBottom: theme.spacing['3'],
  },
  actionText: {
    color: theme.colors.KALE,
  },
});

// ─── Types ───────────────────────────────────────────────────────────

type NotificationsPreferencesNoticeProps = {
  notice: string;
  actionText: string;
  onPress: () => void;
};
